module.exports = __webpack_public_path__ + "static/img/common_indicator_wl.cec6749b.png";